<template>
  <i class="mainIcon">
    <template v-if="name === 'phone'">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none">
      <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M16.5 12.69v2.25a1.502 1.502 0 0 1-1.635 1.5 14.843 14.843 0 0 1-6.472-2.303 14.625 14.625 0 0 1-4.5-4.5A14.843 14.843 0 0 1 1.59 3.135 1.5 1.5 0 0 1 3.083 1.5h2.25a1.5 1.5 0 0 1 1.5 1.29 9.63 9.63 0 0 0 .525 2.107A1.5 1.5 0 0 1 7.02 6.48l-.952.952a12 12 0 0 0 4.5 4.5l.952-.952a1.5 1.5 0 0 1 1.583-.338c.68.254 1.387.43 2.107.526a1.5 1.5 0 0 1 1.29 1.522Z"/>
    </svg>
    </template>
  </i>
</template>

<script>


export default {
  name: "MainIcon",
  props: ['name']
}
</script>


<style scoped lang="scss">
.mainIcon {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
